import React from 'react';
import MessageDisplay from './MessageDisplay';
import ConfirmationForm from './ConfirmationForm';

function RegistrationConfirmation(props) {
  const { message, isLoading, ...other } = props;
  if (message || isLoading) {
    return <MessageDisplay message={message} isLoading={isLoading} />;
  }
  return <ConfirmationForm {...other} />;
}

export default RegistrationConfirmation;
